import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesProverkaFormMain } from './modules/ui/Main';

const ServicesProverkaFormPage = (
  <SuspensePage>
    <PagesServicesProverkaFormMain />
  </SuspensePage>
);

export default ServicesProverkaFormPage;
